import { MentionData } from '@draft-js-plugins/mention'
import { convertFromRaw, RawDraftContentState } from 'draft-js'

import buildEntities from './buildEntitiesFromMentions'

export default function createMentionEntities(
  rawData: RawDraftContentState,
  mentions: MentionData[],
  value: string | undefined
) {
  const [rawEntities, selectedMentions] = buildEntities(value, mentions)

  rawData.entityMap = {
    ...rawData.entityMap,
    ...rawEntities
  }
  rawData.blocks = rawData.blocks.map(block => {
    const ranges: { key: any; length: any; offset: any }[] = []
    selectedMentions
      ?.sort((a, b) => {
        return a.name.length - b.name.length
      })
      .forEach((mention: MentionData) => {
        const findMentionStringLocation = (mention: string, blockText: string | any[]) => {
          const a = []
          let i = -1
          while ((i = blockText.indexOf(mention, i + 1)) >= 0) a.push(i)
          return a
        }
        //need to force a space at then end of a line break so that we can idenitfy mention that ends on a line.
        const replaceCarriageReturnsWithTrialingSpace = (value: string) => value.replaceAll(/[\n\r]+/g, ' ')
        //adding trailing space to end of text block because markdownToDraft strips that space and we need it in place to identify the end of a mention.
        const stringLocations = findMentionStringLocation(
          mention.name,
          replaceCarriageReturnsWithTrialingSpace(block.text) + ' '
        )

        stringLocations.forEach(location => {
          ranges.push({
            key: mention.name,
            length: mention.name.length,
            offset: location
          })
        })
      })
    const entityRanges = block.entityRanges || []
    return { ...block, entityRanges: [...ranges, ...entityRanges] }
  })
  return convertFromRaw(rawData)
}
